import type { LocalPositions } from './local-positions.types';

const POSITION_COMPONENTS = 3;
const X = 0;
const Y = 1;
const Z = 2;
const HALF = 0.5;

// Projected-CRS scene coordinates reach millions of metres, where float32 only
// resolves about half a metre; vertices are stored relative to a float64 origin
// that the caller sets as the mesh position.
export function toLocalPositions(positions: readonly number[]): LocalPositions {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (let i = 0; i < positions.length; i += POSITION_COMPONENTS) {
    minX = Math.min(minX, positions[i + X]);
    maxX = Math.max(maxX, positions[i + X]);
    minY = Math.min(minY, positions[i + Y]);
    maxY = Math.max(maxY, positions[i + Y]);
  }
  const origin = { x: (minX + maxX) * HALF, y: (minY + maxY) * HALF };
  const local = new Float32Array(positions.length);
  for (let i = 0; i < positions.length; i += POSITION_COMPONENTS) {
    local[i + X] = positions[i + X] - origin.x;
    local[i + Y] = positions[i + Y] - origin.y;
    local[i + Z] = positions[i + Z];
  }
  return { origin, local };
}
